import { useState } from "react";
import { Link } from "react-router-dom";
import landingStyle from "../styles/landing.module.scss";
import {
  passwordErrorMessage,
  requestPasswordReset,
} from "../utilities/passwordAccount";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedEmail = email.trim().toLowerCase();

    if (!trimmedEmail) {
      setMessage("Enter the email for this account.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      await requestPasswordReset(trimmedEmail);
      setSent(true);
    } catch (error) {
      setMessage(
        passwordErrorMessage(
          error,
          "Unable to send a reset email right now. Try again in a moment.",
        ),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={landingStyle.loginView}>
      <form className={landingStyle.loginForm} onSubmit={handleSubmit}>
        <div className={landingStyle.formHeader}>
          <p className={landingStyle.stateLabel}>Password</p>
          <h3>{sent ? "Check your email" : "Forgot password"}</h3>
          <p>
            {sent
              ? "If that email is on file, a reset link is on its way."
              : "Enter your account email. We will send a reset link if it is on file."}
          </p>
        </div>

        {sent ? (
          <Link className={landingStyle.textLink} to="/">
            Back to sign in
          </Link>
        ) : (
          <>
            <div className={landingStyle.loginInputGroup}>
              <label htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                autoComplete="email"
                placeholder="you@brand.com"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                  setMessage("");
                }}
              />
              {message ? (
                <div className={landingStyle.loginErrorMessage}>{message}</div>
              ) : null}
            </div>
            <button
              className={`${landingStyle.button} ${
                !email.trim() ? landingStyle.buttonDisabled : ""
              }`}
              type="submit"
              disabled={!email.trim() || loading}
            >
              {loading ? "Sending..." : "Send reset link"}
            </button>
            <Link className={landingStyle.textLink} to="/">
              Back to sign in
            </Link>
          </>
        )}
      </form>
    </div>
  );
}

export default ForgotPassword;
